module.exports = __webpack_public_path__ + "static/media/blueFile.053d165b.svg";